import { convertAngleToDirection } from "./utils";

export class DPadHandler {
    constructor(t, n) {
        this.outputPrefix = n;
        this.lastDirection = "";
        this.previous = "";
        this.pressed = false;
        this.hapticIntensity = "low";
        this.centerRadius = 0.95;
        this.el = t;
        this.deadzone = 0.9;
    }

    addEventListeners() {
        this.el.addEventListener("axismove", this.emitDPad4.bind(this));
        this.el.addEventListener("trackpaddown", this.press.bind(this));
        this.el.addEventListener("trackpadup", this.unpress.bind(this));
        this.el.addEventListener("touchpaddown", this.press.bind(this));
        this.el.addEventListener("touchpadup", this.unpress.bind(this));
    }

    removeEventListeners() {
        this.el.removeEventListener("axismove", this.emitDPad4.bind(this));
        this.el.removeEventListener("trackpaddown", this.press.bind(this));
        this.el.removeEventListener("trackpadup", this.unpress.bind(this));
        this.el.removeEventListener("touchpaddown", this.press.bind(this));
        this.el.removeEventListener("touchpadup", this.unpress.bind(this));
    }

    press(event) {
        this.pressed = true;
    }

    unpress() {
        this.pressed = false;
    }

    emitDPad4(event) {
        event.detail.axis[1] *= -1;
        const xAxis = event.detail.axis[0];
        const yAxis = event.detail.axis[1];

        if (
            Math.abs(xAxis) < this.deadzone &&
            Math.abs(yAxis) < this.deadzone &&
            !this.pressed &&
            event.target.emit("move", event.detail)
        ) {
            return;
        }

        if (!event.detail.changed[0] && !event.detail.changed[1]) {
            return;
        }

        const position =
            Math.abs(xAxis) < this.centerRadius &&
            Math.abs(yAxis) < this.centerRadius
                ? "center"
                : convertAngleToDirection(Math.atan2(xAxis, -yAxis));
        const state = (this.pressed ? "pressed_" : "") + position;

        if (xAxis === 0 && yAxis === 0) {
            event.target.emit(`${this.outputPrefix}_dpad4_${this.previous}_up`);
            event.target.emit(`${this.outputPrefix}_dpad4_up`);
            this.previous = "";
            return;
        }

        if (state !== this.previous) {
            if (this.previous !== "") {
                event.target.emit(
                    `${this.outputPrefix}_dpad4_${this.previous}_up`
                );
            }
            event.target.emit(`${this.outputPrefix}_dpad4_${state}_down`);
            this.previous = state;
        }
    }
}
